import React, { useEffect, useState } from 'react'
import $ from 'jquery'

export default function Feedback() {
    const active_pro_name = localStorage.getItem('selected_project_name');
    const [feedList, setFeedList] = useState([]);
    const [selectedFeedContent, setSelectedFeedContent] = useState('');
    const [alertMsg, setAlertMsg] = useState('');
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [membretype, setMembertype] = useState(false);
    useEffect(() => {
         let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        const active_pro_id = localStorage.getItem('selected_project_id');

        const formData = new FormData();
        formData.append("pro_id", active_pro_id);

        fetch('getFeedList.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(result => {
                if (result.status === "success") {
                    setFeedList(result.data);
                } else {
                    alert(result.message);
                }
            })
            .catch(err => {
                console.error(err);
            });

    }, []); // ✅ IMPORTANT

    function openreplybox(id) {
        document.getElementById('sendreply').style.display = "block"
        setSelectedFeedContent(feedList[id].feed_content);
    }

    function closeAddReplyPOP() {
        document.getElementById('sendreply').style.display = "none"
    }

    const showAlert = (msg) => {
        setAlertMsg(msg);
        setShowAlertBox(true);
    };

    const closeAlert = () => {
        setShowAlertBox(false);
        setAlertMsg('');
    };
    function sendreplyForFeedback() {
        const active_pro_id = localStorage.getItem('selected_project_id');
        const replytext = document.getElementById('reply_description').value;
        const feedtext = selectedFeedContent;
        const useremail = localStorage.getItem('useremail');
        const companyname = localStorage.getItem('mem_company_name');
        document.getElementById('mailloader').style.display = "block";
        closeAddReplyPOP()
        const formData = new FormData();
        formData.append("pro_id", active_pro_id);
        formData.append("replytext", replytext);
        formData.append("feedtext", feedtext);
        formData.append("useremail", useremail);
        formData.append("companyname", companyname);

        fetch('sendReplyMail.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())

            .then(result => {
                console.log(result)
                if (result.status === "success") {
                    document.getElementById('mailloader').style.display = "none";
                    showAlert("Reply sent successfully");
                } else {
                    alert(result.message);
                }
            })
            .catch(err => {
                console.error(err);
            });
    }
    return (
        <div>
            <div className='topbar_menu'>
                <h2 className='details_pop_heading'>Client Feedback</h2>

            </div>
            <div className='member_row'>
                <div className='member_details'>
                    <section className='vl_dsh_bodypart_section pos_rel'>
                        <div className='vl_listing_area'>
                            {feedList.length === 0 ? (
                                <p className='mt-30'>No updates found</p>
                            ) : (
                                feedList.map((item, index) => (
                                    <div className='feedrow' key={index}>
                                        <h2 className='feedheading'>
                                            Feedback for {item.pro_name}
                                            <span>{item.create_at}</span>
                                        </h2>

                                        <div className='feedcontent'>
                                            <p>{item.feed_content}</p>

                                            {/* ✅ CONDITIONAL ATTACHMENT */}
                                            {item.file_path && item.file_path !== "" && (
                                                <div className='feedattachement'>
                                                    <h3>Attachment</h3>
                                                    <a className='member_button' href={item.file_path} target="_blank" rel="noreferrer">
                                                        View File
                                                    </a>

                                                </div>
                                            )}
                                            <div className='replybtnholder'>
                                                <p> Client can see your reply in his mail. The feedback content also go with your reply</p>
                                                <button onClick={() => { openreplybox(index) }}>Send Reply</button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </section>
                </div>
            </div>
            <div className='vl_dsh_popup_vis nodisplay' id="sendreply">
                <div className='vl_dsh_pop_content'>
                    <button className='vl_dsh_pop_content_close' onClick={closeAddReplyPOP}>+</button>
                    <h2 className='vl_dsh_pop_content_heading'>Send Reply</h2>
                    <div className='upload_section'>
                        <div className='formfieldholder'>
                            <label>Insert your reply here as per the feedback</label>
                            <textarea id="reply_description" placeholder='Insert reply text'></textarea>
                        </div>

                        <div className='buttonholder'>
                            <button onClick={sendreplyForFeedback}>Send</button>
                        </div>
                    </div>
                </div>
            </div>

            {showAlertBox && (
                <div className='vl_dsh_popup'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>{alertMsg}</p>
                        </div>

                        <div className='alert_btns'>
                            <button onClick={closeAlert}>Okay</button>
                        </div>
                    </div>
                </div>
            )}
            <div className='loaderpop' id="mailloader">
                <p className='loadertext'>Please wait...</p>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
